import { createSelector } from "reselect";
import { getIsParentLocation } from "features/location/selectors/getIsParentLocation";

export const getCataloguePageTitle = createSelector(getIsParentLocation, (isParent) => {
    return isParent ? "Brand Catalogue" : "Catalogue";
});
